/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Cta_LabelInputs */

const vi_shop_home_cta_label = /** @type {(inputs: Shop_Home_Cta_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chữ trên nút`)
};

/**

* @param {Shop_Home_Cta_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_cta_label = /** @type {((inputs?: Shop_Home_Cta_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Cta_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_cta_label(inputs)
});